window.reparacoesData = {
  "asus-zenfone-8": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "189,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-zenfone-8-flip": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "189,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-zenfone-7": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "149,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-zenfone-7-pro": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "149,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "59,90€" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-zenfone-6": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "89,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "79,90€" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone-5-pro": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone-5-ultimate": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "Sob consulta" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone-5": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "199,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone-3-strix": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "189,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone-3": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "189,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone-2": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "139,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "49,90€" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  },
  "asus-rog-phone": {
    "Display/Touch": [{ nome: "Substituição de Display/Touch", preco: "79,90€" }],
    "Bateria": [{ nome: "Substituição de Bateria", preco: "Sob consulta" }],
    "Conector de Carga": [{ nome: "Substituição de Conector de Carga", preco: "Sob consulta" }],
    "Câmera frontal": [{ nome: "Substituição de Câmera frontal", preco: "Sob consulta" }],
    "Câmera Traseira": [{ nome: "Substituição de Câmera Traseira", preco: "Sob consulta" }],
    "Tampa Traseira": [{ nome: "Substituição de Tampa Traseira", preco: "Sob consulta" }],
    "Descreve a avaria": [{ nome: "Substituição de Descreve a avaria", preco: "Sob consulta" }]
  }
};